import { render, staticRenderFns } from "./BaoCaoTraPhong.vue?vue&type=template&id=06c3a587&"
import script from "./BaoCaoTraPhong.vue?vue&type=script&lang=js&"
export * from "./BaoCaoTraPhong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports